"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowNumericEditor_1 = require("../../../../../../../../shared/components/editors/CardRowNumericEditor");
var CardRowTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var BonusTournamentPrizesEditor = /** @class */ (function (_super) {
    __extends(BonusTournamentPrizesEditor, _super);
    function BonusTournamentPrizesEditor(props) {
        return _super.call(this, props) || this;
    }
    BonusTournamentPrizesEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_APT = this.props.listBonusPrizeType.Subscribe("*", function (id, data) {
            _this.setState({ availPrizeTypes: data.data });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_currency_id: _item.app_currency_id,
                    app_currency_title: _item.app_currency_title,
                    prize_place_number: _item.prize_place_number,
                    description: _item.description,
                    prize_type_code: _item.prize_type_code,
                    prize_type_title: _item.prize_type_title,
                    is_bonus: _item.is_bonus,
                    is_cash: _item.is_cash,
                    is_dream: _item.is_dream,
                    is_points: _item.is_points,
                    bonus_template_id: _item.bonus_template_id,
                    bonus_template_title: _item.bonus_template_title,
                    availPrizeTypes: [],
                    bonus_points_prize_amount: _item.bonus_points_prize_amount,
                    bonus_cash_prize_amount: _item.bonus_cash_prize_amount,
                    bonus_dream_text_val: _item.bonus_dream_text_val
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Турниры", "Изменить приз турнира"]);
                });
            }
        }
        else {
            this.setState({
                app_currency_id: 0,
                app_currency_title: "",
                prize_place_number: 0,
                description: "",
                prize_type_code: 0,
                prize_type_title: "",
                is_bonus: false,
                is_cash: false,
                is_dream: false,
                is_points: false,
                bonus_template_id: 0,
                bonus_template_title: "",
                availPrizeTypes: [],
                bonus_points_prize_amount: 0,
                bonus_cash_prize_amount: 0,
                bonus_dream_text_val: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Турниры", "Добавить приз турнира"]);
            });
        }
        this.props.listBonusPrizeType.LoadData();
        this.doReSetRules();
    };
    BonusTournamentPrizesEditor.prototype.componentWillUnmount = function () {
        this.props.listBonusPrizeType.UnSubscribe(this.SID_APT);
    };
    BonusTournamentPrizesEditor.prototype.doReSetRules = function () {
        this.setState({
            app_currency_rules: { isError: false },
            prize_type_rules: { isError: false },
            bonus_template_rules: { isError: false }
        });
    };
    BonusTournamentPrizesEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_currency_id <= 0) || (this.state.app_currency_title.length === 0)) {
            this.setState({ app_currency_rules: { isError: true, errorMessage: "Валюта не выбрана!" } });
            return false;
        }
        if ((this.state.prize_type_code <= 0) || (this.state.prize_type_title.length === 0)) {
            this.setState({ prize_type_rules: { isError: true, errorMessage: "Тип приза не выбран!" } });
            return false;
        }
        if (this.state.is_bonus) {
            if ((this.state.bonus_template_id <= 0) || (this.state.bonus_template_title.length === 0)) {
                this.setState({ bonus_template_rules: { isError: true, errorMessage: "Бонус не выбран!" } });
                return false;
            }
        }
        return true;
    };
    BonusTournamentPrizesEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_currency_id: this.state.app_currency_id,
                bonus_tournament_id: this.props.rootRecord.key,
                prize_place_number: this.state.prize_place_number,
                bonus_cash_prize_amount: this.state.bonus_cash_prize_amount,
                bonus_dream_text_val: this.state.bonus_dream_text_val,
                bonus_points_prize_amount: this.state.bonus_points_prize_amount,
                bonus_template_id: this.state.bonus_template_id,
                prize_type_code: this.state.prize_type_code,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Сумма турнира добавлена!");
            });
        }
    };
    BonusTournamentPrizesEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                app_currency_id: this.state.app_currency_id,
                key: this.props.record.key,
                prize_place_number: this.state.prize_place_number,
                bonus_cash_prize_amount: this.state.bonus_cash_prize_amount,
                bonus_dream_text_val: this.state.bonus_dream_text_val,
                bonus_points_prize_amount: this.state.bonus_points_prize_amount,
                bonus_template_id: this.state.bonus_template_id,
                prize_type_code: this.state.prize_type_code,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Сумма турнира изменена!");
            });
        }
    };
    BonusTournamentPrizesEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusTournamentPrizesEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить приз турнира";
        }
        else {
            return "Изменить приз турнира";
        }
    };
    BonusTournamentPrizesEditor.prototype.getRenderInput = function () {
        var _this = this;
        if (this.state.is_bonus) {
            return (React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бонус:", placeholder: "Выберите бонус" }, value: { key: this.state.bonus_template_id, value: this.state.bonus_template_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_template_id: newVal.key,
                        bonus_template_title: newVal.value,
                        bonus_template_rules: { isError: false }
                    });
                }, items: this.props.availBonuses, required: true, rules: this.state.bonus_template_rules }));
        }
        if (this.state.is_cash) {
            return (React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Сумма приза в деньгах:", placeholder: "Введите сумму приза в деньгах" }, values: { max: 999999, min: 1, value: this.state.bonus_cash_prize_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_cash_prize_amount: newVal
                    });
                }, precision: 2 }));
        }
        if (this.state.is_points) {
            return (React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Сумма приза в пойнтах:", placeholder: "Введите сумму приза в пойнтах" }, values: { max: 999999, min: 1, value: this.state.bonus_points_prize_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_points_prize_amount: newVal
                    });
                }, precision: 2 }));
        }
        if (this.state.is_dream) {
            return (React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание приза:", placeholder: "Введите описание приза" }, value: this.state.bonus_dream_text_val, onValueChanged: function (newVal) {
                    _this.setState({
                        bonus_dream_text_val: newVal
                    });
                } }));
        }
    };
    BonusTournamentPrizesEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BonusTournamentPrizesEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 500 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Валюта:", placeholder: "Выберите валюту" }, value: { key: this.state.app_currency_id, value: this.state.app_currency_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_currency_id: newVal.key,
                        app_currency_title: newVal.value,
                        app_currency_rules: { isError: false }
                    });
                }, items: this.props.availCurrency, required: true, rules: this.state.app_currency_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Призовое место:", placeholder: "Введите призовое место" }, values: { max: 999999, min: 1, value: this.state.prize_place_number }, onValueChanged: function (newVal) {
                    _this.setState({
                        prize_place_number: newVal
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип приза:", placeholder: "Выберите тип приза" }, value: { key: this.state.prize_type_code, value: this.state.prize_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        prize_type_code: newVal.key,
                        prize_type_title: newVal.value,
                        prize_type_rules: { isError: false }
                    }, function () {
                        _this.setState({
                            is_bonus: _this.props.listBonusPrizeType.getByIdKeyValEx(_this.state.prize_type_code).is_bonus,
                            is_cash: _this.props.listBonusPrizeType.getByIdKeyValEx(_this.state.prize_type_code).is_cash,
                            is_dream: _this.props.listBonusPrizeType.getByIdKeyValEx(_this.state.prize_type_code).is_dream,
                            is_points: _this.props.listBonusPrizeType.getByIdKeyValEx(_this.state.prize_type_code).is_points
                        });
                    });
                }, items: this.state.availPrizeTypes, required: true, rules: this.state.prize_type_rules }),
            this.getRenderInput(),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal
                    });
                } }),
            this.getDownButtons()));
    };
    return BonusTournamentPrizesEditor;
}(React.Component));
exports.default = BonusTournamentPrizesEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/prizes/BonusTournamentsPrizesEditor.tsx
// module id = 2515
// module chunks = 0